import { toAmount, toAmountOrZero } from "@/shared/amount";

interface LoanAmountParts {
	approvedCashAmount?: number | null;
	finalLoanAmount?: number | null;
	debtsToBeRedeemed?: number | null;
}

/**
 * The part of the loan that reaches the customer's account. `finalLoanAmount`
 * carries the refinance, so it has to come back out before the rest is cash.
 */
export const resolveApprovedCashAmount = (
	offer?: LoanAmountParts | null,
	appliedRefinance = 0
): number => {
	const applied = Math.max(toAmountOrZero(appliedRefinance), 0);
	const approvedCashAmount = toAmount(offer?.approvedCashAmount);
	const finalLoanAmount = toAmount(offer?.finalLoanAmount);

	if (finalLoanAmount === null) {
		return approvedCashAmount ?? 0;
	}

	const refinanced = Math.max(
		applied,
		toAmountOrZero(offer?.debtsToBeRedeemed)
	);

	if (approvedCashAmount === null) {
		return Math.max(finalLoanAmount - refinanced, 0);
	}

	// FLOW has been seen reporting a cash amount the refinance was never taken
	// out of, which would count that refinance twice.
	return Math.max(
		Math.min(approvedCashAmount, finalLoanAmount - refinanced),
		0
	);
};
